import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/AdminLogin.css';
import { getApiBaseUrl } from '../utils/apiConfig';


const AdminLogin = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const API_BASE = getApiBaseUrl();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const res = await axios.post(`${API_BASE}/api/login`, { email, password });
            localStorage.setItem('token', res.data.token);

            if (onLogin) {
                onLogin(); // ✅ notify parent of login
            }

            navigate('/admin-dashboard'); // ✅ navigate after updating auth state
        } catch (err) {
            setError('Invalid email or password');
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-container">
                <h2>Admin Login</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                    />
                    <button type="submit" className="login_submmit">Login</button>
                    {error && <p className="error-message">{error}</p>}
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
